import { ActingType, JwtPayload } from '@oiambk/oiam-oauth-types';

export class JWTReaderService {

  static isValidJwt(jwt: string): boolean {
    return !!jwt && jwt.length > 0;
  }

  /**
   * liefert das JWT-Payload als Objekt
   */
  private static parseJwtPayload(jwt: string): JwtPayload {
    if (jwt != null) {
      const ajwt = jwt.split('.');
      if (ajwt.length === 3) {
        const payload = ajwt[1];
        const utf8CleanedUpPayload = payload
          .replace(/\s+/g, '')
          .replace(/-/g, '+')
          .replace(/_/g, '/');
        const binString = atob(utf8CleanedUpPayload);
        const uint8Array = new Uint8Array(binString.length);

        for (let i = 0; i < binString.length; i++) {
          uint8Array[i] = binString.charCodeAt(i);
        }

        const decodedPayload = new TextDecoder().decode(uint8Array);
        return JSON.parse(decodedPayload);
      }
    }
    return null;
  }

  static getActingTypeFromJwt(jwt: string): ActingType | undefined {
    if (!jwt) return;

    const jwtPayload = this.parseJwtPayload(jwt);
    if (!jwtPayload) return;
    return jwtPayload['acting-type'];
  }

}
